import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Drawer, Theme } from "@material-ui/core";
import { useCommonWidths } from "../../../../hooks";
import {
	leftMenuWidthMobile,
	headerHeight,
	headerHeightMobile,
} from "../../../../constants";

const useStyles = makeStyles((theme: Theme) => ({
	flyoutMenu: {
		width: 400,
		[theme.breakpoints.down("sm")]: {
			width: leftMenuWidthMobile,
			height: `calc(100vh - ${headerHeightMobile}px)`,
		},
		height: `calc(100vh - ${headerHeight}px)`,
		backgroundColor: "#FFF",
		transition: "transform .3s cubic-bezier(0, .52, 0, 1)",
		overflowX: "hidden",
		borderLeftWidth: "2px",
		borderLeftStyle: "ridge",
		borderLeftColor: "white",
	},
}));

export interface FlyOutMenuProps {
	open: boolean;
	toggleMenu: () => void;
	children?: any;
}
export const FlyOutMenu = (props: FlyOutMenuProps) => {
	const classes = useStyles();
	const isMobile = useCommonWidths().isSmDown;

	return (
		<Drawer
			open={props.open}
			anchor="right"
			variant={isMobile ? "temporary" : "persistent"}
			onClose={(e) => {
				props.toggleMenu();
			}}
		>
			<div id="flyoutMenu" className={classes.flyoutMenu}>
				{props.children}
			</div>
		</Drawer>
	);
};
